/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { IApi } from "./api/api";
import { App } from "./app/app";
import { Site } from "./site/site";
import { APP_PATH } from "./paths/pathIndex";

interface IProps {
    api: IApi;
}

class ScaperWithoutRouter extends React.PureComponent<IProps & RouteComponentProps<any>, {}> {
    public render() {
        return (
            <Switch>
                <Route path={APP_PATH} render={this.renderApp} />
                <Route render={this.renderSite} />
            </Switch>
        );
    }

    private renderApp = () => {
        const { api } = this.props;
        return <App api={api} />;
    };

    private renderSite = () => {
        const { api } = this.props;
        return <Site api={api} />;
    };
}

export const Scaper = withRouter(ScaperWithoutRouter);
